import React from "react";
import { usePage } from "@inertiajs/react";

/**
 * Compact "Powered by FaithConnect®" attribution.
 * Hidden when SHOW_POWERED_BY_FAITHCONNECT is false.
 */
export default function PoweredByFaithConnect({
    prefix = " - ",
    className = "underline text-blue-600 dark:text-blue-400",
    linkClassName,
}) {
    const { showPoweredByFaithConnect } = usePage().props;

    if (!showPoweredByFaithConnect) {
        return null;
    }

    return (
        <>
            {prefix}
            Powered by{" "}
            <a
                className={linkClassName ?? className}
                href="https://www.faithconnect.com"
                target="_blank"
                rel="noopener noreferrer"
            >
                FaithConnect®
            </a>
        </>
    );
}
